// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M6 7.5C6 4.46243 8.46243 2 11.5 2C14.5376 2 17 4.46243 17 7.5C17 10.5376 14.5376 13 11.5 13C8.46243 13 6 10.5376 6 7.5ZM11.75 22H2V20C2 16.6863 4.68629 14 8 14H11.75V22ZM13.75 14H22.25V16H13.75V14ZM13.75 17H22.25V19H13.75V17ZM13.75 20H22.25V22H13.75V20Z"}}]};

const UserListFilledIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'user-list-filled',
    ref,
    icon: element,
  },
));

UserListFilledIcon.displayName = 'UserListFilledIcon';

export default UserListFilledIcon;
